import { MapLayerIds, MAP_THREEJS_LAYER_IDS } from './map-config.constants';

/**
 * Design overlay layers hidden while measuring a PDF scale, so nothing paints
 * over the drawing. Includes sibling-building fills and the three.js silhouette.
 */
export const MEASURE_ISOLATION_LAYER_IDS: string[] = [
  MAP_THREEJS_LAYER_IDS.extrusion,
  MAP_THREEJS_LAYER_IDS.wireframe,
  MAP_THREEJS_LAYER_IDS.points,
  MAP_THREEJS_LAYER_IDS.silhouette,
  MapLayerIds.BuildingExtrusion,
  MapLayerIds.BuildingRoofLine,
  MapLayerIds.BuildingExtrusionTransparent,
  MapLayerIds.BuildingFill2d,
  MapLayerIds.OtherBuildingsFill,
  MapLayerIds.OtherBuildingsLine,
  MapLayerIds.Line,
  MapLayerIds.Points,
  MapLayerIds.PointsHit,
  MapLayerIds.DraftLine,
  MapLayerIds.DraftPoints,
  MapLayerIds.LocationPin,
];

export type MeasureIsolationVisibility = 'none' | 'visible';

/**
 * First-seen visibility for a layer while measure isolation is on.
 * Layers that appear after a style reload restore to visible; layers present
 * at isolation start keep their live Mapbox value so 2D-hidden layers stay hidden.
 */
export const captureMeasureIsolationVisibility = (input: {
  alreadyCaptured: boolean;
  current: unknown;
  appearedDuringIsolation: boolean;
}): MeasureIsolationVisibility | undefined => {
  if (input.alreadyCaptured) return undefined;
  if (input.appearedDuringIsolation) return 'visible';
  return input.current === 'none' ? 'none' : 'visible';
};
